/* theme.js — per-device theme preference (cabin wood/copper vs. card-felt
 * green/suit-red). Persisted to localStorage, applied via [data-theme] on
 * <html> so theme.css's token overrides take effect. Each phone picks its
 * own look; nothing here touches Firestore or other players' devices. */
const KEY = 'cabin-pinochle-theme-v1';

export const THEMES = [
  { id: 'cabin', label: 'Cabin' },
  { id: 'feltcard', label: 'Card Felt' },
];

function apply(id) {
  document.documentElement.dataset.theme = id;
}

// call once, before first paint, so there's no flash of the wrong theme
export function initTheme() {
  let saved = null;
  try { saved = localStorage.getItem(KEY); } catch { /* private mode */ }
  apply(THEMES.some((t) => t.id === saved) ? saved : THEMES[0].id);
}

export function getTheme() {
  return document.documentElement.dataset.theme || THEMES[0].id;
}

export function setTheme(id) {
  apply(id);
  try { localStorage.setItem(KEY, id); } catch { /* private mode — won't persist across reloads */ }
}

export function nextTheme() {
  const i = THEMES.findIndex((t) => t.id === getTheme());
  const next = THEMES[(i + 1) % THEMES.length];
  setTheme(next.id);
  return next;
}
